import { MinimalShell } from "../components/layout/MinimalShell";

const Section = ({ title, children }) => (
  <div className="mb-9">
    <h2 className="font-display text-2xl text-cream mb-3">{title}</h2>
    <div className="text-cream/70 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </div>
);

export default function CookiePolicy() {
  return (
    <MinimalShell>
      <section data-testid="cookie-policy" className="relative pt-32 pb-24 bg-depth-a overflow-hidden">
        <div className="aurora-weave slow" />
        <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8">
          <p className="text-xs tracking-[0.28em] uppercase text-[#E7CC86]/75 mb-4">Gary Malkin Enterprises</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl text-cream mb-3">Cookie Policy</h1>
          <p className="text-cream/50 mb-12">What cookies are, and how we use them here.</p>

          <Section title="What cookies are">
            <p>Cookies are small text files stored on your device that help a website function and remember your preferences.</p>
          </Section>
          <Section title="How we use them">
            <p><span className="text-cream">Essential</span> — required for the site to work and to remember your cookie choice.</p>
            <p><span className="text-cream">Analytics</span> — help us understand which content resonates so we can improve the experience.</p>
          </Section>
          <Section title="Managing your preferences">
            <p>You can choose “Accept All” or “Essential Only” from the banner. To change your choice later, clear this site's cookies in your browser and reload — the banner will appear again.</p>
          </Section>
          <Section title="More information">
            <p>For how we handle personal information, see our Privacy Policy.</p>
          </Section>
        </div>
      </section>
    </MinimalShell>
  );
}
